// Mock data for Overdressed Couture splash page
// NOTE: All data below is mocked for the frontend-only teaser.

export const brand = {
  name: "Overdressed Couture",
  tagline: "Pretty Polished & Purposeful",
  logo: "/odc-logo.png",
};

export const navLinks = [
  { label: "Where to Find Us Live", href: "#find-us" },
  { label: "New in", href: "#new-in" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const contact = {
  eyebrow: "Get in Touch",
  title: "Contact Us",
  text: "Questions, styling help, collaborations, or press? Reach out and Precious and the Overdressed Couture team will get right back to you.",
  email: "admin@overdressedcouture.com",
};

export const hero = {
  ribbon: ["Overdressed Couture", "Pretty", "Polished", "Purposeful"],
  wordOne: "PRETTY",
  wordTwo: "POLISHED",
  microTagline: "Pretty Polished & Purposeful",
  model:
    "https://customer-assets.emergentagent.com/job_fashion-studio-92/artifacts/xu10nres_hero-model-DbgJPZ-F.png",
};

export const liveSubtitle =
  "Shop everyday clothes, statement fits, and everything in between. Live with @OverdressedCouture.";

export const marketplaces = [
  {
    id: 1,
    name: "Palmstreet",
    handle: "@OverdressedCouture",
    tag: "Live Now",
    accent: "#17A67B",
    iconName: "TreePalm",
    url: "https://palmstreet.app/u/OverdressedCouture?pr=haHJYjuP",
  },
  {
    id: 2,
    name: "Whatnot",
    handle: "@OverdressedCouture",
    tag: "Live Auctions",
    accent: "#FFD400",
    logo:
      "https://customer-assets.emergentagent.com/job_fashion-studio-92/artifacts/68m9o6o1_whatnot%20logo.png",
    url: "https://whatnot.com/s/jsSVZhj2",
  },
  {
    id: 3,
    name: "Facebook Shop",
    handle: "Overdressed Couture",
    tag: "Shop Now",
    accent: "#1877F2",
    logo:
      "https://customer-assets.emergentagent.com/job_fashion-studio-92/artifacts/z4ftoz9y_Facebook-shop-300x300.png",
    url: "https://www.facebook.com/share/1CUdU7wCz6/",
  },
  {
    id: 4,
    name: "Poshmark",
    handle: "@odcouture",
    tag: "Closet Open",
    accent: "#822432",
    logo:
      "https://customer-assets.emergentagent.com/job_fashion-studio-92/artifacts/bna00ctg_Poshmark-Logo-500x281.png",
    url: "https://posh.mk/JJVPhBvvH4b",
  },
  {
    id: 5,
    name: "Instagram",
    handle: "@myoverdressedcouture",
    tag: "Shop the Feed",
    accent: "#E1306C",
    iconName: "Instagram",
    url: "https://www.instagram.com/myoverdressedcouture?utm_source=qr&igsh=azUyMXF1czVkYndj",
  },
];

export const newIn = [
  {
    id: 1,
    name: "The Ruched Slit Gown",
    price: "$128",
    image:
      "https://customer-assets.emergentagent.com/job_fashion-studio-92/artifacts/xu10nres_hero-model-DbgJPZ-F.png",
    badge: "Best Seller",
  },
  {
    id: 2,
    name: "Noir Cut-Out Maxi",
    price: "$142",
    image: "https://images.unsplash.com/photo-1623580674393-edf6eb7090f8",
    badge: "New",
  },
  {
    id: 3,
    name: "Silhouette Satin",
    price: "$156",
    image: "https://images.unsplash.com/photo-1568251188392-ae32f898cb3b",
    badge: "New",
  },
  {
    id: 4,
    name: "Glimmer Evening Dress",
    price: "$168",
    image: "https://images.unsplash.com/photo-1551113006-731674fbb3ff",
    badge: "Limited",
  },
];

export const merch = [
  {
    id: 1,
    type: "White Tee",
    slogan: "Overdressed",
    image: "https://images.unsplash.com/photo-1618677603286-0ec56cb6e1b5",
    light: true,
  },
  {
    id: 2,
    type: "White Tee",
    slogan: "Pretty Polished & Purposeful",
    image: "https://images.unsplash.com/photo-1618677603286-0ec56cb6e1b5",
    light: true,
  },
  {
    id: 3,
    type: "Ladies Cap",
    slogan: "Overdressed",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    light: true,
  },
  {
    id: 4,
    type: "Ladies Cap",
    slogan: "Pretty Polished & Purposeful",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    light: true,
  },
  {
    id: 5,
    type: "Women's Leggings",
    slogan: "Overdressed",
    image: "https://images.unsplash.com/photo-1706029831374-e236f69cbe8b",
    light: false,
  },
  {
    id: 6,
    type: "Women's Leggings",
    slogan: "Pretty Polished & Purposeful",
    image: "https://images.unsplash.com/photo-1706029831374-e236f69cbe8b",
    light: false,
  },
];

export const about = {
  eyebrow: "About Us",
  title: "Pretty, Polished & Purposeful",
  paragraphs: [
    "Founded in 2019, Overdressed Couture is built on purposeful dressing that adds confidence and joy, one remarkable outfit at a time.",
    "We are here to bring out the best style in every woman, with pieces that speak to her body, her silhouette, and the events in her life. Overdressed Couture is for the woman who values quality and enjoys getting dressed for her own confidence.",
    "The way you dress talks to the world about who you are, and Overdressed Couture is here to make that process effortless. Through curated collections and themed boutique parties, you can look polished without spending hours searching.",
  ],
  cta: "Read Our Story",
};

export const founder = {
  eyebrow: "Meet the Founder",
  name: "Precious Ward-Nieves",
  role: "Founder & CEO",
  photo: "/founder.png",
  bio: [
    "I started Overdressed Couture in 2019 with a simple belief: getting dressed should add confidence and joy, one remarkable outfit at a time.",
    "I'm here to let women know there is a very happy balance to getting dressed and still being put together and polished, whether it's work, home, a girls night, or a special family occasion. You don't have to settle for leggings and yoga pants in between work and play, and you don't have to settle for anything less than feeling good and well put together with your family or running errands.",
  ],
  quote:
    "Pretty, Polished and Purposeful. That's the promise behind every piece.",
  storyTitle: "The Story Behind Overdressed Couture",
  story: [
    "Overdressed Couture was born from the marvelous, creative matriarchs in my life. From a very young age, my grandmother and mother taught me the importance of how to adorn my body and carry myself with grace.",
    "I still remember the joy of my friends and me filling small spaces with big glamour everywhere we went in our small town. Lost in the racks, I found beauty in everything from a seven-dollar piece to a high-end department store find.",
    "Along the way, I learned that culture and confidence collide, and that what we express through textiles, fit, and personality sets the tone for the day.",
    "Overdressed Couture is here to help you sprinkle your own glitter of beauty at every table you sit at and every door you enter. A mark to leave that is unforgettable, striding in with intention, class, and style.",
  ],
  badges: [
    { icon: "Award", label: "Black-Owned" },
    { icon: "Sparkles", label: "Woman-Owned" },
    { icon: "HeartHandshake", label: "Community-Rooted" },
  ],
};

export const affiliation = {
  eyebrow: "Proud Affiliate",
  heading: "SURE Program Alumna",
  text: "Founder & CEO Precious Ward-Nieves is a graduate of the SURE Program, Stimulating Urban Renewal through Entrepreneurship, at the University of Houston's C. T. Bauer College of Business. The program empowers local, under-resourced entrepreneurs with the foundational business skills to build and grow their companies.",
  logo: "/sure-logo.png",
};

export const community = {
  eyebrow: "Our Commitment",
  title: "Rooted in Community",
  text: "Overdressed Couture is a proudly Black-owned, woman-owned small business built to uplift. We believe fashion should give back, investing in the women and neighborhoods that raised us.",
  points: [
    {
      icon: "Users",
      title: "Community First",
      text: "We partner with local organizations and reinvest in the community that supports us.",
    },
    {
      icon: "HeartHandshake",
      title: "Give-Back Program",
      text: "A portion of every collection goes toward empowering women and girls in our area.",
    },
    {
      icon: "Sparkles",
      title: "Confidence for All",
      text: "Size-inclusive, body-loving design so every woman feels seen and celebrated.",
    },
  ],
};

export const footer = {
  columns: [
    { title: "Shop", links: ["New In", "Gowns", "Bodycon", "Accessories"] },
    { title: "The House", links: ["About", "Find Us Live", "Sizing", "Contact"] },
    { title: "Help", links: ["Shipping", "Returns", "FAQ", "Track Order"] },
  ],
  social: [
    { label: "Palmstreet", url: "https://palmstreet.app/u/OverdressedCouture?pr=haHJYjuP" },
    { label: "Whatnot", url: "https://whatnot.com/s/jsSVZhj2" },
    { label: "Facebook", url: "https://www.facebook.com/share/1CUdU7wCz6/" },
    { label: "Poshmark", url: "https://posh.mk/JJVPhBvvH4b" },
    { label: "Instagram", url: "https://www.instagram.com/myoverdressedcouture?utm_source=qr&igsh=azUyMXF1czVkYndj" },
  ],
};
